<template>
    <Chart
        card
        class="mt-3"
        :height="400"
        :series="[]"
        :options="chartOptions"
        :header="$t('sales')"
        :error="requestChart.getError()"
        :loading="requestChart.getLoading()"
        :range="groupBy"
    />
</template>



<script>
    import Chart from '@/components/common/Chart.vue';
    import { chartDataGroupBy, generateChartData } from '@/utils/chart';

    export default {
        name: 'ChartData',
        components: {
            Chart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.parentComponent.requestSalesChart,
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                return {
                    urlParams: {
                        id: this.item.id,
                    },
                    requestParams: {
                        ...(this.timeRange || {}),
                        groupBy: this.groupBy,
                    },
                };
            },
            groupBy() {
                return chartDataGroupBy(this.timeRange);
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartOptions() {
                const chartData = this.chartData.reduce(
                    (acc, item) => {
                        acc.amount.push([item.date, item.amount]);
                        acc.quantity.push([item.date, item.quantity]);
                        return acc;
                    },
                    { amount: [], quantity: [] }
                );
                return {
                    series: [
                        {
                            name: this.$t('quantityPieces'),
                            type: 'line',
                            data: generateChartData(this.parentComponent.timeRange, chartData.quantity, this.groupBy),
                        },
                        {
                            name: this.$t('salesAmount'),
                            type: 'bar',
                            data: generateChartData(this.parentComponent.timeRange, chartData.amount, this.groupBy),
                        },
                    ],
                    yaxis: [
                        {
                            title: {
                                text: this.$t('quantityPieces'),
                            },
                        },
                        {
                            opposite: true,
                            title: {
                                text: this.$t('salesAmount'),
                            },
                        },
                    ],
                };
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'loadData',
            },
            timeRange: {
                immediate: false,
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.fetchChart();
            },
            fetchChart(params = {}) {
                this.requestChart.get(this.apiParams);
            },
        },
    };
</script>



<style lang="scss" scoped></style>
